<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-skeleton-loader
          v-if="isPageLoading"
          class="mx-auto"
          type="card"
        ></v-skeleton-loader>

        <banking-form
          v-else
          :saveLoading="saveLoading"
          @submit="save">
        </banking-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { selectedFleetId } from '../../mixins/fleets.mixins';
import BankingForm from '../../components/BankingForm.vue';

export default {
  components: { BankingForm },
  data() {
    return {
      saveLoading: false,
      userIpAddress: null,
      isPageLoading: true,
    };
  },
  mixins: [selectedFleetId],
  async mounted() {
    this.isPageLoading = true;
    this.userIpAddress = await this.getUserIpAddress();
    this.isPageLoading = false;
  },
  methods: {
    ...mapActions({
      setDefaultBankingAccount: 'bankingAccount/setDefaultBankingAccount',
      showSuccess: 'globalMessages/addSuccess',
      showError: 'globalMessages/addError',
      getUserIpAddress: 'utils/getUserIpAddress',
    }),
    async save(account) {
      this.saveLoading = true;
      try {
        const result = await this.setDefaultBankingAccount({
          account: {
            accountNumber: account.accountNumber,
            routingNumber: account.routingNumber,
            country: account.country,
            currency: account.currency,
            accountHolderName: account.accountHolderName,
          },
          fleetId: this.selectedFleetId,
          userIpAddress: this.userIpAddress,
        });
        if (result) {
          this.showSuccess({ message: 'bankingOnboarding.informationSuccessfullySent' });
          this.$router.push('/captures');
        }
        this.saveLoading = false;
      } catch (error) {
        this.showError({ message: 'bankingOnboarding.setDefaultBankingAccountError' });
        this.saveLoading = false;
      }
    },
  },
};
</script>
